module.exports = __webpack_public_path__ + "img/Wrestling.7352274a.png";